/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonCompanyDurationInfo,
    JsonCompanyDurationInfoFromJSON,
    JsonCompanyDurationInfoFromJSONTyped,
    JsonCompanyDurationInfoToJSON,
} from './JsonCompanyDurationInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonCompanyDurationInfo
 */
export interface ApiResultOfJsonCompanyDurationInfo {
    /**
     * 
     * @type {JsonCompanyDurationInfo}
     * @memberof ApiResultOfJsonCompanyDurationInfo
     */
    data?: JsonCompanyDurationInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyDurationInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonCompanyDurationInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyDurationInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyDurationInfo
     */
    result?: ApiResultOfJsonCompanyDurationInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonCompanyDurationInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonCompanyDurationInfoFromJSON(json: any): ApiResultOfJsonCompanyDurationInfo {
    return ApiResultOfJsonCompanyDurationInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonCompanyDurationInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonCompanyDurationInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonCompanyDurationInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonCompanyDurationInfoToJSON(value?: ApiResultOfJsonCompanyDurationInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonCompanyDurationInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

